import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import { siteConfig, getAffiliateLink } from '../config/site'
import { updateSEO } from '../utils/seo'
import { loadArticle } from '../utils/loadArticle'
import { getGlobalHubSlug, getSegmentPageSlugs } from '../utils/getSlugs'
import { markdownToHtml } from '../utils/markdownToHtml'
import './ArticlePage.css'

const GlobalHubPage = () => {
  const { locale, t, translations } = useLocale()
  const [pageData, setPageData] = useState(null)
  const [loading, setLoading] = useState(true)
  const globalHubSlug = getGlobalHubSlug(translations)
  const segmentPages = getSegmentPageSlugs(translations)

  useEffect(() => {
    const loadPage = async () => {
      setLoading(true)
      const data = await loadArticle(globalHubSlug, locale, 'page')
      setPageData(data)
      
      if (data) {
        updateSEO({
          title: data.metaTitle,
          description: data.metaDescription,
          keywords: data.metaKeywords,
          url: `${siteConfig.baseUrl}/${globalHubSlug}`
        })
      }
      setLoading(false)
    }
    loadPage()
  }, [locale, globalHubSlug])

  if (loading) {
    return <div className="article-page-container"><div className="loading">{t('pages.loading')}</div></div>
  }

  if (!pageData) {
    return <div className="article-page-container"><div>{t('pages.pageNotFound')}</div></div>
  }

  return (
    <div className="article-page-container">
      <div className="article-content">
        {pageData.hook && (
          <div className="article-section hook-section" dangerouslySetInnerHTML={{ __html: markdownToHtml(pageData.hook) }} />
        )}
        {pageData.overview && (
          <div className="article-section" dangerouslySetInnerHTML={{ __html: markdownToHtml(pageData.overview) }} />
        )}
        {pageData.apps_guide && (
          <div className="article-section" dangerouslySetInnerHTML={{ __html: markdownToHtml(pageData.apps_guide) }} />
        )}
        {pageData.safety_tips && (
          <div className="article-section" dangerouslySetInnerHTML={{ __html: markdownToHtml(pageData.safety_tips) }} />
        )}
        {pageData.success_stories && (
          <div className="article-section" dangerouslySetInnerHTML={{ __html: markdownToHtml(pageData.success_stories) }} />
        )}
        {pageData.faq && (
          <div className="article-section faq-section">
            <h2>{pageData.faq.title}</h2>
            <div className="faq-list">
              {pageData.faq.items?.map((item, i) => (
                <div key={i} className="faq-item">
                  <h3 className="faq-question">{item.question}</h3>
                  <p className="faq-answer">{item.answer}</p>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <div className="affiliate-cta">
          <a href={getAffiliateLink()} target="_blank" rel="noopener noreferrer" className="affiliate-button">
            {t('pages.globalHub.affiliateCTA')}
          </a>
        </div>

        {/* Internal links to segment pages */}
        <div className="internal-links-section">
          <h3>{t('pages.globalHub.moreGuides')}</h3>
          <ul className="internal-links-list">
            {segmentPages.map((page) => {
              // Map page type to locale key
              const linkKeyMap = {
                'apps': 'apps',
                'comparison': 'bestSites',
                'hookups': 'hookups',
                'adult': 'sexDating',
                'advice': 'howToDate',
                'tips': 'tips',
                'ranking': 'topApps'
              }
              const linkKey = linkKeyMap[page.type] || page.type
              return (
                <li key={page.slug}>
                  <Link to={`/${page.slug}`}>
                    {t(`pages.globalHub.internalLinks.${linkKey}`)}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default GlobalHubPage

